export default {
  type: 'tab-pane',
  isAbsoluteLayout: true,
  style: {
    width: '100%',
    backgroundColor: 'rgba(201, 201, 201, 1)',
  },
  tabTitle: {
    style: {
      width: '100%',
      backgroundColor: 'rgba(201, 201, 201, 1)',
      height: '40',
    },
    disabledStyle: {
      backgroundColor: 'rgba(226, 226, 226, 0.5)',
    },
  },
  items: [],
  devconfig: {
    lock: true,
    pack: false,
    resizable: false,
    aspectRatio: false,
    ratio: 1,
  },
  dtEid: 'tab-panel',
};
